export default function PrivacyPolicy() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <header className="mb-10">
        <h1 className="text-3xl font-semibold mb-4">
          Polityka prywatności
        </h1>
        <p className="text-sm text-gray-500">
          Obowiązuje od: <strong>2.10.2025</strong>
        </p>
      </header>

      {/* §1 */}
      <article className="mb-10">
        <h2 className="text-xl font-semibold mb-3">
          §1. Postanowienia ogólne
        </h2>
        <div className="space-y-3 leading-relaxed">
          <p>
            Niniejsza Polityka Prywatności dotyczy użytkowników strony internetowej
            dostępnej pod adresem:
            <span className="font-medium"> https://maciejglab.pl/</span>.
          </p>
          <p>
            Administratorem danych osobowych jest
            <strong> Maciej Głąb</strong>
            (dalej: „Administrator” lub „My”).
          </p>
        </div>
      </article>

      {/* §2 */}
      <article className="mb-10">
        <h2 className="text-xl font-semibold mb-3">
          §2. Przetwarzanie danych osobowych
        </h2>

        <p className="mb-4 leading-relaxed">
          Działając zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE)
          2016/679 (RODO), informujemy, że przetwarzamy dane osobowe wyłącznie w
          jasno określonych celach i w niezbędnym zakresie.
        </p>

        <h3 className="font-medium mb-2">Cele przetwarzania danych:</h3>
        <ul className="list-disc pl-6 space-y-2 leading-relaxed">
          <li>
            realizacja umów oraz działania podejmowane przed ich zawarciem
            (art. 6 ust. 1 lit. b RODO),
          </li>
          <li>
            obsługa zapytań przesyłanych przez formularze kontaktowe
            (art. 6 ust. 1 lit. f RODO),
          </li>
          <li>
            rozpatrywanie reklamacji i skarg
            (art. 6 ust. 1 lit. b RODO),
          </li>
          <li>
            realizacja obowiązków prawnych, w tym podatkowych i księgowych
            (art. 6 ust. 1 lit. c RODO),
          </li>
          <li>
            wysyłka newslettera – na podstawie udzielonej zgody
            (art. 6 ust. 1 lit. a RODO),
          </li>
          <li>
            poprawa jakości usług (ankiety, statystyki, analizy)
            (art. 6 ust. 1 lit. f RODO),
          </li>
          <li>
            prowadzenie kampanii marketingowych w mediach społecznościowych
            (art. 6 ust. 1 lit. a RODO).
          </li>
        </ul>

        <div className="mt-6 space-y-3 leading-relaxed">
          <p>
            Podanie danych osobowych jest dobrowolne, jednak w niektórych
            przypadkach niezbędne do skorzystania z usług.
          </p>
          <p>
            Zgoda na przetwarzanie danych może zostać cofnięta w dowolnym
            momencie, bez wpływu na zgodność z prawem wcześniejszego
            przetwarzania.
          </p>
          <p>
            Cofnięcie zgody możliwe jest poprzez link lub wiadomość e-mail:
            <span className="italic text-gray-600"> maciekglabphoto@gmail.com</span>.
          </p>
        </div>

        <h3 className="font-medium mt-6 mb-2">
          Prawa osób, których dane dotyczą:
        </h3>
        <ul className="list-disc pl-6 space-y-2 leading-relaxed">
          <li>dostęp do danych osobowych,</li>
          <li>ich sprostowanie, usunięcie lub ograniczenie przetwarzania,</li>
          <li>wniesienie sprzeciwu wobec przetwarzania,</li>
          <li>przenoszenie danych,</li>
          <li>złożenie skargi do organu nadzorczego.</li>
        </ul>

        <p className="mt-4 leading-relaxed">
          Dane transakcyjne przekazywane są bezpośrednio do operatorów płatności
          i nie są przechowywane przez Administratora.
        </p>
      </article>

      {/* §3 */}
      <article className="mb-10">
        <h2 className="text-xl font-semibold mb-3">
          §3. Odbiorcy danych
        </h2>
        <p className="leading-relaxed">
          Korzystamy z usług sprawdzonych podmiotów świadczących usługi
          informatyczne i techniczne. Podmioty te przetwarzają dane wyłącznie na
          podstawie zawartych umów powierzenia i zgodnie z naszymi instrukcjami.
        </p>
      </article>

      {/* §4 */}
      <article>
        <h2 className="text-xl font-semibold mb-3">
          §4. Pliki cookies
        </h2>

        <div className="space-y-3 leading-relaxed">
          <p>
            Strona wykorzystuje pliki cookies zapisywane w przeglądarce
            użytkownika. Służą one prawidłowemu działaniu serwisu oraz analizie
            statystyk.
          </p>
          <p>
            Cookies nie dają nam dostępu do urządzenia użytkownika ani innych
            danych poza informacjami zapisanymi w tych plikach.
          </p>

          <div className="bg-gray-50 border rounded-lg p-4">
            <p className="font-medium mb-2">Dostawcy:</p>
            <p>
              <strong>Google Firebase</strong>
              <br />
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Polityka prywatności Google
              </a>
            </p>
            <p className="text-sm text-gray-600 mt-2">
              Narzędzia te służą do zarządzania bazą danych oraz danymi użytkownika po zarejestrowaniu.
            </p>
          </div>
        </div>
      </article>
    </section>
  );
}
